import {makeService} from './api';

const service = makeService('invoices');

export default service;
